export const profile = {
    'profile_account': 'Account',
    'profile_name': 'Name',
    'profile_email': 'Email',
    'profile_add_email': 'Add email',
    'profile_add_email_title': 'Add email',
    'profile_add_email_description': 'Enter your email address and your password. We will email a 6-digit verification code to this address.',
    'profile_change_email': 'Change email',
    'profile_change_email_title': 'Change email',
    'profile_change_email_description': 'Enter your new email address and your password. We will email a 6-digit verification code to the new address and a security alert to your current one.',
    'profile_change_email_error': 'Error requesting the email change',
    'profile_change_email_invalid_password': 'The current password is incorrect',
    'profile_change_email_same_email': 'The new email must be different from the current one',
    'profile_change_email_verified': 'Your email address has been updated. Please log in again.',
    'profile_change_email_cancelled': 'The pending email change has been removed.',
    'profile_change_email_discard_error': 'Error removing the pending email change',
    'profile_pending_confirmation': 'Pending confirmation',
    'profile_pending_email_hint': 'Check your inbox for the 6-digit verification code.',
    'profile_pending_email_replace_hint': 'Check your inbox for the 6-digit verification code. Your current email stays active until confirmation.',
    'profile_change_phone': 'Change phone number',
    'profile_change_phone_title': 'Change phone number',
    'profile_change_phone_description': 'Enter your new phone number and your password. We will text a 6-digit verification code to the new number and a security alert to your current one.',
    'profile_change_phone_error': 'Error requesting the phone number change',
    'profile_change_phone_invalid_password': 'The current password is incorrect',
    'profile_change_phone_same_phone': 'The new phone number must be different from the current one',
    'profile_change_phone_exists': 'This phone number is already used by another account',
    'profile_change_phone_invalid_number': 'Enter a valid phone number',
    'profile_change_phone_verified': 'Your phone number has been updated. Please log in again.',
    'profile_change_phone_cancelled': 'The pending phone number change has been removed.',
    'profile_change_phone_discard_error': 'Error removing the pending phone number change',
    'profile_pending_phone_hint': 'Check your SMS for the 6-digit verification code.',
    'profile_pending_phone_replace_hint': 'Check your SMS for the 6-digit verification code. Your current phone number stays active until confirmation.',
    'profile_verification_code_step_description': 'Enter the 6-digit verification code we sent.',
    'profile_verification_code': 'Verification code',
    'profile_verification_code_placeholder': '6-digit code',
    'profile_verification_code_verify': 'Verify',
    'profile_action_processing': 'Processing...',
    'profile_verification_code_resend': 'Resend code',
    'profile_verification_code_resend_in': 'Resend code in {{seconds}}s',
    'profile_verification_code_expires_in': 'Code expires in about {{minutes}} min.',
    'profile_verification_code_expired_hint': 'This code has expired. Request a new code.',
    'profile_verification_code_invalid': 'The verification code is invalid',
    'profile_verification_code_expired': 'This verification code has expired. Request a new code.',
    'profile_verification_code_too_many_attempts': 'Too many failed attempts. Request a new code.',
    'profile_verification_code_resend_rate_limited': 'Please wait before requesting another code.',
    'profile_change_email_code_description': 'Enter the 6-digit code sent to {{value}}.',
    'profile_change_email_code_description_fallback': 'Enter the 6-digit code sent to your email address.',
    'profile_change_phone_code_description': 'Enter the 6-digit code sent to {{value}}.',
    'profile_change_phone_code_description_fallback': 'Enter the 6-digit code sent to your phone number.',
    'profile_change_nickname': 'Change pseudonym',
    'profile_change_nickname_title': 'Change pseudonym',
    'profile_change_nickname_description': 'Enter your new pseudonym and your password.',
    'profile_change_nickname_success': 'Your pseudonym has been updated.',
    'profile_change_nickname_error': 'Error updating the pseudonym',
    'profile_change_nickname_invalid_password': 'The current password is incorrect',
    'profile_change_nickname_same_nickname': 'The new pseudonym must be different from the current one',
    'profile_change_password': 'Change password',
    'profile_password': 'Password',
    'profile_phone': 'Phone number',
    'profile_add_phone': 'Add phone number',
    'profile_add_phone_title': 'Add phone number',
    'profile_add_phone_description': 'Enter your phone number and your password. We will text a 6-digit verification code to this number.',
    'profile_not_provided': 'Not provided',
    'profile_study_info': "Study information",
    'profile_view_consent': "View consent",
    'profile_opt_out': "Opt out",
    'profile_opt_out_message': "Do you want to quit the study?",
    'profile_allow_access_data': "Keep my data anonymously",
    'profile_website': "Research Website",
    'profile_contact': "Contact Researchers",
    'profile_report_bug': 'Report a bug',
    'profile_information_note': 'Information note',
    'profile_download_pdf': 'Download',
    'profile_download_pdf_loading': 'Downloading...',
    'profil_langue' : 'Language',
    'profile_pseudonym': 'Pseudonym',
    'profile_nir_opposition': 'Object to the SNDS transfer',
    'profile_nir_opposition_done': 'SNDS objection recorded',
    'profile_nir_opposition_title': 'Objection to the SNDS transfer',
    'profile_nir_opposition_message': 'Your social security number will be permanently deleted and never transmitted for linkage with the national health data system (SNDS). This decision has no consequence on your participation in the study and is irreversible.',
    'profile_nir_opposition_confirm': 'Confirm my objection',
    'profile_nir_opposition_success': 'Your objection has been recorded.',
}